module.exports = __webpack_public_path__ + "assets/img/face.97cd28dd.png";